<template>
  <div class="qaqc-overview-status-card qaqc-test-plot-wrapper">
    <h6 class="qaqc-status-panel-title">Quality Control Status</h6>
    <p class="qaqc-status-panel-subtitle">{{ panel.subtitle }}</p>
    <div class="qaqc-status-panel-blocks">
      <div class="qaqc-status-block qaqc-status-passed">
        <div class="qaqc-status-block-top">
          <div class="qaqc-status-block-icon">
            <v-img :src="icons.passed" width="20" height="20" alt="" />
          </div>
          <div class="qaqc-status-block-content">
            <div class="qaqc-status-block-title-wrap">
              <span class="qaqc-status-block-title">Passed QC</span>
              <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
                <template v-slot:activator="{ props }">
                  <v-img
                    v-bind="props"
                    :src="infoIcon"
                    class="qaqc-test-info-icon qaqc-overview-note-icon"
                    width="18"
                    height="18"
                    alt=""
                    aria-label="Metric description"
                  />
                </template>
                <div class="qaqc-test-tooltip-content">{{ qcNotes.passed }}</div>
              </v-tooltip>
            </div>
            <span class="qaqc-status-block-details">{{ panel.passed.count }} of {{ panel.passed.total }} tests</span>
          </div>
        </div>
        <div class="qaqc-status-block-progress-row">
          <div class="qaqc-status-block-progress-track">
            <div class="qaqc-status-block-progress-fill" :style="{ width: progressWidth(panel.passed.percent) }"></div>
          </div>
          <span class="qaqc-status-block-percent">{{ panel.passed.percent }}</span>
        </div>
      </div>
      <div class="qaqc-status-block qaqc-status-review">
        <div class="qaqc-status-block-top">
          <div class="qaqc-status-block-icon">
            <v-img :src="icons.review" width="20" height="20" alt="" />
          </div>
          <div class="qaqc-status-block-content">
            <div class="qaqc-status-block-title-wrap">
              <span class="qaqc-status-block-title">Needs Review</span>
              <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
                <template v-slot:activator="{ props }">
                  <v-img
                    v-bind="props"
                    :src="infoIcon"
                    class="qaqc-test-info-icon qaqc-overview-note-icon"
                    width="18"
                    height="18"
                    alt=""
                    aria-label="Metric description"
                  />
                </template>
                <div class="qaqc-test-tooltip-content">{{ qcNotes.needsReview }}</div>
              </v-tooltip>
            </div>
            <span class="qaqc-status-block-details">{{ panel.needsReview.count }} of {{ panel.needsReview.total }} tests</span>
          </div>
        </div>
        <div class="qaqc-status-block-progress-row">
          <div class="qaqc-status-block-progress-track">
            <div class="qaqc-status-block-progress-fill" :style="{ width: progressWidth(panel.needsReview.percent) }"></div>
          </div>
          <span class="qaqc-status-block-percent">{{ panel.needsReview.percent }}</span>
        </div>
      </div>
      <div class="qaqc-status-block qaqc-status-failed">
        <div class="qaqc-status-block-top">
          <div class="qaqc-status-block-icon">
            <v-img :src="icons.failed" width="20" height="20" alt="" />
          </div>
          <div class="qaqc-status-block-content">
            <div class="qaqc-status-block-title-wrap">
              <span class="qaqc-status-block-title">Failed QC</span>
              <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
                <template v-slot:activator="{ props }">
                  <v-img
                    v-bind="props"
                    :src="infoIcon"
                    class="qaqc-test-info-icon qaqc-overview-note-icon"
                    width="18"
                    height="18"
                    alt=""
                    aria-label="Metric description"
                  />
                </template>
                <div class="qaqc-test-tooltip-content">{{ qcNotes.failed }}</div>
              </v-tooltip>
            </div>
            <span class="qaqc-status-block-details">{{ panel.failed.count }} of {{ panel.failed.total }} tests</span>
          </div>
        </div>
        <div class="qaqc-status-block-progress-row">
          <div class="qaqc-status-block-progress-track">
            <div class="qaqc-status-block-progress-fill" :style="{ width: progressWidth(panel.failed.percent) }"></div>
          </div>
          <span class="qaqc-status-block-percent">{{ panel.failed.percent }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OVERVIEW_QC_STATUS_NOTES } from "./overviewDashboardNotes.js";

export default {
  name: "QCStatusPanel",
  data() {
    return { 
      qcNotes: OVERVIEW_QC_STATUS_NOTES,
      infoIcon: require("@/assets/Svg/infoIcon.svg"),
      icons: {
        passed: require("@/assets/Svg/Icons/tick-circle.svg"),
        review: require("@/assets/Svg/Icons/info-circle.svg"),
        failed: require("@/assets/Svg/Icons/cross-circle.svg"),
      },
     };
  },
  props: {
    panel: {
      type: Object,
      required: true,
      default: () => ({
        passed: { count: 0, total: 0, percent: "0%" },
        needsReview: { count: 0, total: 0, percent: "0%" },
        failed: { count: 0, total: 0, percent: "0%" },
        subtitle: "",
      }),
    },
    sampleIds: { type: Array, default: () => [] },
    selectedSampleIds: { type: Array, default: () => [] },
  },
  emits: ["update:selectedSampleIds"],
  methods: {
    progressWidth(percent) {
      return /^\d+(\.\d+)?%$/.test(percent) ? percent : "0%";
    },
    addSampleId(id) {
      if (this.selectedSampleIds.includes(id)) return;
      this.$emit("update:selectedSampleIds", [...this.selectedSampleIds, id]);
    },
    removeSampleId(id) {
      this.$emit(
        "update:selectedSampleIds",
        this.selectedSampleIds.filter((s) => s !== id)
      );
    },
  },
};
</script>
